module.exports = __webpack_public_path__ + "img/trouble-2.25ae97b5.png";